import { createI18n, type I18n } from 'vue-i18n'

const localeModules = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json')

const resolveInitialLocale = (): string => {
  const storedLocale =
    sessionStorage.getItem('app_locale') ||
    localStorage.getItem('app_locale')

  if (storedLocale && (storedLocale === 'cn' || storedLocale === 'gb')) {
    return storedLocale
  }

  return 'cn'
}

export const loadLocaleMessages = async (locale: string): Promise<Record<string, string>> => {
  const loader = localeModules[`./locales/${locale}.json`]
  if (!loader) return {}

  const localeModule = await loader()
  return localeModule.default
}

export const setupI18n = async (): Promise<I18n> => {
  const initialLocale = resolveInitialLocale()
  const messages: Record<string, Record<string, string>> = {}

  messages[initialLocale] = await loadLocaleMessages(initialLocale)

  if (initialLocale !== 'gb') {
    messages.gb = await loadLocaleMessages('gb')
  }

  return createI18n({
    legacy: false,
    // Default to Chinese for first load when no user preference is stored
    locale: initialLocale,
    fallbackLocale: 'gb',
    messages,
  })
}

export default setupI18n
